import { render, staticRenderFns } from "./Coa.vue?vue&type=template&id=6a007f60&scoped=true&"
import script from "./Coa.vue?vue&type=script&lang=js&"
export * from "./Coa.vue?vue&type=script&lang=js&"
import style0 from "./Coa.vue?vue&type=style&index=0&id=6a007f60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a007f60",
  null
  
)

export default component.exports